import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, createStore as reduxCreateStore, StoreEnhancer } from "redux";

import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";

import { makeRootReducer } from "redux/reducers";
import { rootSaga } from "redux/sagas";
import { State } from "redux/state";

import { authMiddleware } from "./middleware";

import { composeWithDevTools } from '@redux-devtools/extension';
import { isDev } from "utils/environment";

export function createStore() {
    const history = createBrowserHistory();
    const historyMiddleware = routerMiddleware(history);
    const sagaMiddleware = createSagaMiddleware<State>();
    const historyEnhancers = applyMiddleware(thunk, historyMiddleware, sagaMiddleware, authMiddleware);
    // we may want to change it to composeWithDevToolsDevelopmentOnly so it isn't on PROD, or just back to compose from "redux"
    // we need a special NAME so we can easily recognize which store we are looking at

    // for dev name, we get something off the browser?
    // get a time stamp, just hour minutes
    const time = new Date().getMinutes();

    const name = isDev() ? `STUDIO_DEV_${time}` : "OC_STUDIO";
    const composeEnhancers = composeWithDevTools({ name });
    const storeEnhancers: StoreEnhancer = composeEnhancers(historyEnhancers);
    const store: AsyncStore<State> = reduxCreateStore(makeRootReducer(history), storeEnhancers);

    store.runSaga = sagaMiddleware.run;
    store.runSaga(rootSaga);
    store.asyncReducers = {};
    store.asyncSagas = new Map();

    /* For hot module replacement */
    if (module.hot) {
        // If any of the reducers change, we need to replace the current ones
        module.hot.accept("./reducers", () => {
            const makeRootReducer = require("./reducers").default;
            store.replaceReducer(makeRootReducer(history, store.asyncReducers));
        });
    }

    return { store, history };
}
